import { ActionTree, GetterTree, MutationTree } from "vuex";
import { ValidationsStoreTypes } from "@/types/ValidationsTypes";

const state: ValidationsStoreTypes = {
  validDocument: false,
};

const getters: GetterTree<ValidationsStoreTypes, any> = {
  validDocument: (st) => st.validDocument,
};

const mutations: MutationTree<ValidationsStoreTypes> = {
  setValidDocument(st: ValidationsStoreTypes, valid) {
    st.validDocument = valid;
  },
};

const actions: ActionTree<ValidationsStoreTypes, any> = {
  setValidDocument({ commit }, valid) {
    commit("setValidDocument", valid);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
